import { ValueType } from '@nibras/core/common';
import { Dictionary } from './dictionary';

export class BaseModel {
  public ID: number;
  public ParentID: number;
  public AttributeIDMapping: Dictionary<number>;
  public ElementTemplateID: number;
  public Name: string;
  public ShortName: string;
  public Description: string;
}

export interface KeyValueValueType<T> {
  Key: T;
  Value: string;
  ValueTypeID: ValueType;
}

export interface NumberKeyValueValueType extends KeyValueValueType<number> {}
